<h1 mat-dialog-title>Are you sure?</h1>
<mat-dialog-content>
  <div>Are you sure that you want to submit result to this form?</div>
  <div>This action will calculate the results for all bettings of this form.</div>
  <div class="oo-notification-section">
    <mat-checkbox [(ngModel)]="state.notify">Send notification to users?</mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button (click)="close(false)" mat-button>
    Cancel
  </button>
  <button (click)="close(true)" color="warn" mat-button>
    Submit
  </button>
</mat-dialog-actions>
